import { nsSelector } from '../../../../../../../utils/redux';

const gatesSelector = nsSelector('gates');
export const gates = gatesSelector('list');
export const gate = gatesSelector('item');
